export default {
  arrowButtonColor: Styles.color.grey.one,
};
